// The four-square Microsoft logo for the "Sign in with Microsoft" button.
export function MicrosoftIcon({ size = 15 }: { size?: number }) {
  return (
    <span
      style={{
        display: 'inline-grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 2,
        width: size,
        height: size,
      }}
      aria-hidden="true"
    >
      <i style={{ background: '#f25022', borderRadius: 1 }} />
      <i style={{ background: '#7fba00', borderRadius: 1 }} />
      <i style={{ background: '#00a4ef', borderRadius: 1 }} />
      <i style={{ background: '#ffb900', borderRadius: 1 }} />
    </span>
  )
}
